import React, {Component} from 'react';
import { Menu} from 'antd';
import coSvg from "../../../../resources/img/co.svg";
import usSvg from "../../../../resources/img/us.svg";

class PrivateHeaderMenu extends Component {

  handleLanguage = () => {
    this.props.changeLanguage(this.props.language);
  };

  render() {
    return (
      <Menu
        theme="light"
        mode={this.props.mode}
        defaultSelectedKeys={['/']}
        selectedKeys={[this.props.pathname.split('/')[1]]}
        style={{lineHeight: '32px',textAlign:'right'}}
      >

        <Menu.Item onClick={this.handleLanguage}>
          {this.props.language === 'es' ? <img style={{width: 30}} alt={'COL flag'} src={coSvg}/> : <img style={{width: 30}} alt={'US flag'} src={usSvg}/>}
        </Menu.Item>
        {this.props.includeUser?<Menu.Item>
          <div style={{color:'black'}}><i className={'netco-icon'}>Y</i>{this.props.userName}</div>
        </Menu.Item>:''}
      </Menu>
    );
  }
}

export default PrivateHeaderMenu;
